import { render, staticRenderFns } from "./HelpTypeEdit.vue?vue&type=template&id=c02149c6"
import script from "./HelpTypeEdit.vue?vue&type=script&lang=js"
export * from "./HelpTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports